<template>
  <div id="app" v-if="showDisplay">
    <router-view v-show="!($route.name == 'segment')"></router-view>
    <preview></preview>

    <editor
      v-if="$route.name.includes('segment') || $route.name.includes('Segment')"
      v-show="$route.name == 'segment'"
    ></editor>
  </div>
</template>

<script>
import { HTTP } from '../src/core/http/http-common';
import Routing from '../src/core/router/router';
import { mapGetters, mapActions } from 'vuex';
import Preview from '@/components/Preview';
import { bus } from './main';
import mixin from './mixins/Mixin.js';
import mixinEditors from './mixins/GrapesMixinEditors';
import Editor from '@/components/Editor';
export default {
  name: 'app',
  props: ['typeS'],
  data() {
    return {
      showDisplay: false,
    };
  },
  components: {
    Preview,
    Editor,
  },
  mixins: [mixin, mixinEditors],
  created() {
    const lang = this.$route.query.lang || 'fr';
    this.$root.$i18n.locale = lang;
    localStorage.setItem('gjs-components', '');
    localStorage.setItem('gjs-html', '');
    localStorage.setItem('gjs-styles', '');
    localStorage.setItem('gjs-css', '');

    var self = this;

    HTTP.get(
      Routing.generate('api_programDisplay_get_params_display', {
        cryptext: this.$route.params.cryptext,
      }),
    ).then(
      function(response) {
        if (response.data.code == 200) {
          if (response.data) {
            if (!response.data.display_default_blocks) {
              response.data.display_default_blocks = self.getParamsClients.display_default_blocks;
              if (!response.data.modules.show_list_block_action) {
                self.setHiddenBlock(!!response.data.modules.display_layers);
              }
            } else if (
              response.data.display_default_blocks &&
              (Object.keys(response.data.display_default_blocks).length === 0 ||
                !response.data.modules.show_list_block_action)
            ) {
              self.setHiddenBlock(!!response.data.modules.display_layers);
            }
            let hasDevices = true;
            if (
              !response.data.display_devices ||
              Object.keys(response.data.display_devices).length === 0
            ) {
              hasDevices = false;
              response.data.display_devices = self.getParamsClients.display_devices;
            }
            if (
              response.data.display_devices &&
              Object.keys(response.data.display_devices).length === 1
            ) {
              self.setHiddenButtonDevice();
            }
            if (
              !response.data.display_custom_style_manager ||
              Object.keys(response.data.display_custom_style_manager).length === 0
            ) {
              response.data.display_custom_style_manager =
                self.getParamsClients.display_custom_style_manager;
            }
            self.pushParamsClient(response.data);

            const modules = {
              ...response.data.modules,
              can_toggle_slides_action: parseInt(response.data.nb_screen_segment) !== 1,
              nb_screen_segment: response.data.nb_screen_segment,
              display_devices: hasDevices,
            };
            if (
              self.hasPermission('save_video_action') &&
              !self.hasPermission('save_copie_html_action')
            ) {
              self.setSaveVideo(true);
            }
            self.setPermissions(modules);
            if (response.data.auth_token) {
              window.ApiToken = response.data.auth_token;
              //process.env.API_TOCKEN = response.data.auth_token;
              self.showDisplay = true;
            }
            localStorage.setItem('video_intro', response.data.show_video_intro);
            localStorage.setItem('video_generique', response.data.show_generic_display);
            localStorage.setItem('client', response.data.client);
          }
        }
        // self.setDispositions(response.data);
      },
      function(error) {},
    );
    document.body.onmouseup = function() {
      window.dragEnabled = false;
    };
  },
  computed: {
    /**
     * Getters from Vuex Store
     */
    ...mapGetters(['getParamsClients', 'hasPermission']),
  },
  methods: {
    ...mapActions(['pushParamsClient', 'setPermissions']),
    ...mapActions({
      setSaveVideo: 'common/setSaveVideo',
    }),
    ...mapActions('common', ['addToListSvgObject']),
    eventPostMessage() {
      let self = this;
      let code = 'fr';
      let imageUrl, urlMedia, id, comp;
      if (window.dataEventPostMessage === undefined) {
        window.dataEventPostMessage = true;

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
          function(event) {
            var message = event.data;
            if (message !== 'undefined') {
              if (message.postSvg && message.postSvg === true) {
                self.$root.$emit('bv::hide::modal', 'modal-svg-mator');
                self.addToListSvgObject(message);

                //document.getElementsByClassName('gjs-frame')[0].contentDocument.querySelector('#'+message.getImgId).src=message.SVG64;
                if (
                  grapesjsEMP.editors[0].getSelected().attributes.type === 'image_media' ||
                  grapesjsEMP.editors[0].getSelected().attributes.type === 'pattern'
                ) {
                  grapesjsEMP.editors[0].getSelected().set('src', message.SVG64);
                  grapesjsEMP.editors[0].getSelected().view.el.firstChild.src = message.SVG64;
                } else {
                  grapesjsEMP.editors[0].getSelected().set('src', message.SVG64);
                }
              }
              if (message.info === 'updateLang') {
                code = message.lang;
                bus.$emit('setFormLang', code);
                self.$root.$i18n.locale = code;
                self.$i18n.locale = code;
                self.$nextTick(function() {});
              }
              if (message.info && message.info === 'showSocialMedia') {
                if (self.paramsClient.display_default_urls) {
                  imageUrl = self.paramsClient.display_default_urls.social_media_url;
                }
                id = 'social-media';
                comp = 'social_media';
                var selectedElement = grapesjsEMP.editors[0].getSelected();
                if (selectedElement !== undefined) {
                  /* todo url images */
                  try {
                    let style = '';
                    if (message.currentPost.TypeShow === 'fullScreen') {
                      style = {
                        width: '100%',
                        height: '100%',
                        overflow: 'auto',
                        left: '0',
                        top: '0',
                      };
                      window.eventHub.$emit('showToolbarButtons', false);
                    }

                    let objectMedia = {
                      data: message.data,
                      currentPost: message.currentPost,
                    };
                    window.y = objectMedia;
                    selectedElement.set({
                      objectMedia: objectMedia,
                      type: message.currentPost.TypeSocial,
                      'custom-name': message.currentPost.TypeSocial,
                    });

                    selectedElement.setAttributes({
                      id: selectedElement.attributes.attributes.id,
                      style: style,
                      'data-gjs-type': message.currentPost.TypeSocial,
                    });
                  } catch (e) {}
                }
                self.closeModal(comp, id);
              }
              if (message.info && message.info === 'showImage') {
                id = 'image-media';
                comp = 'image_media';
                if (self.paramsClient.display_default_urls) {
                  imageUrl = self.paramsClient.display_default_urls.image_url;
                  urlMedia = self.paramsClient.display_default_urls.url_media;
                }
                var editor = grapesjsEMP.editors[0];
                var selectedElement = editor.getSelected();
                if (selectedElement !== undefined) {
                  var wrapperEl = selectedElement.view.el;
                  var typeEl = selectedElement.attributes.type;

                  /* todo url images */
                  try {
                    if (typeEl === 'image_media') {
                      wrapperEl.querySelector('img') && 
                        wrapperEl.querySelector('img').setAttribute('src', message.src);
                      let img = new Image();
                      img.onload = function() {
                        let data = {
                          className: selectedElement.view.el.classList[0],
                          img,
                        };
                        window.eventHub.$emit('updateWidthImage', data);
                      };
                      img.src = message.src;
                      /*    */
                      if (message.src && message.src !== null) {
                        let extension = message.src.split('.').pop();
                        if (
                          (extension && extension === 'svg') ||
                          selectedElement.attributes.svg === 'svg'
                        ) {
                          selectedElement.set('svg', 'svg');
                          self.ShowToolBar('object-group');
                        } else self.displayToolBar('object-group');
                      }
                      grapesjsEMP.editors[0].select(null);
                    } else if (typeEl === 'pattern') {
                      id = 'pattern';
                      comp = 'pattern';
                      if (self.paramsClient.display_default_urls) {
                        imageUrl = self.paramsClient.display_default_urls.pattern_url;
                      }
                      wrapperEl.querySelector('img') &&
                        wrapperEl.querySelector('img').setAttribute('src', imageUrl);
                      let img = new Image();
                      img.onload = function() {
                        let data = {
                          className: selectedElement.view.el.classList[0],
                          img,
                        };
                        window.eventHub.$emit('updateWidthImage', data);
                      };
                      img.src = imageUrl;
                      /*    */
                      if (message.src && message.src !== null) {
                        let extension = message.src.split('.').pop();
                        if (
                          (extension && extension === 'svg') ||
                          selectedElement.attributes.svg === 'svg'
                        ) {
                          selectedElement.set('svg', 'svg');
                          self.ShowToolBar('object-group');
                        } else self.displayToolBar('object-group');
                      }
                      grapesjsEMP.editors[0].select(null);
                    } else {
                      wrapperEl && wrapperEl.setAttribute('src', message.src);
                      self.updateWrapperProperties(grapesjsEMP.editors[0], message.src);
                    }
                  } catch (e) {}

                  selectedElement.set('src', message.src);
                }
                self.closeModal(comp, id);
              }
            }
          },
          false,
        );
      }
      self.setCloseImageModal(comp, id);
    },
    setHiddenBlock(displayLayers = false) {
      setTimeout(() => {
        const elBlocks = document.querySelector(
          '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
        );
        if (elBlocks) {
          elBlocks.style.display = 'none';
        }
        const elBrush = document.querySelector('#gjs .gjs-pn-buttons .fa-paint-brush');
        if (elBrush) {
          elBrush.style.display = 'none';
        }

        if (!displayLayers) {
          document.querySelector('.gjs-pn-buttons.panel-buttons') &&
          document.querySelector('.gjs-pn-buttons.panel-buttons')
          .setAttribute('style', 'display: none !important;');
          setTimeout(() => {
            if(document.querySelector('.gjs-pn-panel.gjs-pn-views-container') )
              document.querySelector('.gjs-pn-panel.gjs-pn-views-container').style.height = 'calc(100% - 40px)';
          }, 1000);
        }
      }, 100);
    },
    setHiddenButtonDevice() {
      setTimeout(() => {
        if(document.querySelector('.gjs-pn-devices-b')) 
          document.querySelector('.gjs-pn-devices-b').style.display = 'none';
      }, 100);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.eventPostMessage();
    });
  },
};
</script>

<style lang="scss">
html {
  overflow-y: hidden;
}
html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  font-size: 16px;
  font-family: Arial, sans-serif;
  background: #fff;

  .swal2-height-auto {
    height: 100% !important;
  }
}
#app {
  height: 100%;
  width: 100%;
}

.gjs-two-color {
  color: #3c546a !important;
}
.gjs-one-bg {
  background-color: #fff !important;
}
.BG-icon {
  font-size: 0.8em !important;
  color: white;
  background-color: rgba(0, 0, 0, 0.75);
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// App.vue?1686dc7a